var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-52d6364c"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "bookAppointmentHeader" };
const _hoisted_2 = { class: "flex flex-row justify-between items-center" };
const _hoisted_3 = {
    id: "book-appointment-title",
    class: "break-all w-[71%]"
};
const _hoisted_4 = { class: "flex flex-row gap-4" };
const _hoisted_5 = { id: "book-appointment-delete-icon" };
const _hoisted_6 = { id: "book-appointment-close-icon" };
const _hoisted_7 = { key: 0 };
const _hoisted_8 = { key: 2 };
const _hoisted_9 = { key: 3 };
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "border-[0.5px] border-t-[1px] border-gray-200" }, null, -1));
const _hoisted_11 = {
    class: "flex items-center gap-4",
    id: "appointment-status-container"
};
const _hoisted_12 = { class: "text-gray-700 font-medium" };
import { useNotify } from '@/composition/notification';
import { CalendarEventService } from '@/service/CalendarEventService';
import AppState from '@/states/book_appointment';
import { CheckCircleIcon, FaceHappyIcon, FaceSadIcon, Trash01Icon, WatchCircleIcon, XCircleIcon, XCloseIcon, } from '@gohighlevel/ghl-icons/24/outline';
import { UIModal, UIModalFooter, UISpin, UITabPane, UITabs, } from '@gohighlevel/ghl-ui';
import moment from 'moment';
import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import DeleteAppointmentModal from '../common/DeleteAppointmentModal.vue';
import UIDropdown from '../common/UIDropdown.vue';
import BookAppointmentForm from './BookAppointmentForm.vue';
import CreateBlockedTimeForm from './CreateBlockedTimeForm.vue';
import { appointmentWizardState, bookRecurring, calendarDropDownOptions, contactTimezone, hasContact, isEditingAppointment, isNewBlockSlot, selectedCalendar, shouldAllowCustomTime, shouldCollectGuestCountOnly, shouldCollectGuestInfo, showCountError, validateGuestCount, } from './appointmentWizardState';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AppointmentWizard',
    props: {
        showModal: Boolean,
        onCancelClick: Function,
        isEdit: Boolean,
    },
    setup(__props) {
        const props = __props;
        const { sendNotification } = useNotify();
        const { t } = useI18n();
        const dynamicWidth = ref(0);
        const dynamicHeight = ref('');
        const prevCustomTimeValue = ref(false);
        const showDeleteModal = ref(false);
        const selectedStatusOption = ref({
            label: t('appointmentModal.confirmed'),
            value: 'confirmed',
            icon: CheckCircleIcon,
        });
        watch(() => appointmentWizardState.appointmentStatus, newValue => {
            if (newValue) {
                const foundOption = statusOptions.value.find(option => option.value === newValue);
                if (foundOption)
                    selectedStatusOption.value = foundOption;
            }
        });
        // Gets the appropriate header text for the appointment modal based on the action being performed.
        const getModalHeaderText = () => {
            const actionKey = isNewBlockSlot.value
                ? AppState.isEdit
                    ? 'block_time'
                    : 'add_blocked_off_time'
                : AppState.isEdit
                    ? 'edit_appointment'
                    : 'book_appointment';
            return t(`appointmentModal.${actionKey}`);
        };
        // Gets the appropriate footer text for the appointment modal based on the action being performed.
        const getModalFooterText = () => {
            const actionKey = isNewBlockSlot.value
                ? AppState.isEdit
                    ? 'save_event'
                    : 'block_time'
                : AppState.isEdit
                    ? 'save_appointment'
                    : 'book_appointment';
            return t(`appointmentModal.${actionKey}`);
        };
        // Computed property that generates status options for appointments based on edit and new event conditions.
        const statusOptions = computed(() => {
            var _a;
            let options = [
                {
                    label: t('appointmentModal.confirmed'),
                    value: 'confirmed',
                    icon: CheckCircleIcon,
                },
            ];
            if (isEditingAppointment.value) {
                options = [
                    ...options,
                    {
                        label: t('appointmentModal.cancelled'),
                        value: 'cancelled',
                        icon: XCircleIcon,
                    },
                    {
                        label: t('appointmentModal.showed'),
                        value: 'showed',
                        icon: FaceHappyIcon,
                    },
                    {
                        label: t('appointmentModal.no_show'),
                        value: 'noshow',
                        icon: FaceSadIcon,
                    },
                    {
                        label: t('appointmentModal.invalid'),
                        value: 'invalid',
                        icon: WatchCircleIcon,
                    },
                ];
            }
            if (!(isEditingAppointment.value &&
                AppState.isEdit &&
                ((_a = appointmentWizardState.oldAppointment) === null || _a === void 0 ? void 0 : _a.appointmentStatus) !== 'new')) {
                options.push({
                    label: t('appointmentModal.unconfirmed'),
                    value: 'new',
                    icon: XCircleIcon,
                });
            }
            return options;
        });
        // Sets the selected appointment status and updates the appointmentWizardState.
        const setSelectedAppointmentStatus = (e) => {
            selectedStatusOption.value = e;
            appointmentWizardState.appointmentStatus = e.value;
        };
        // Handles tab switching between new appointment and block time creation.
        const onClickTab = (type) => {
            if (type === 'blockedOff') {
                prevCustomTimeValue.value = AppState.shouldAllowCustomTime;
                AppState.shouldAllowCustomTime = true;
            }
            else {
                AppState.shouldAllowCustomTime = prevCustomTimeValue.value;
            }
            AppState.isNewBlockSlot = !AppState.isNewBlockSlot;
            appointmentWizardState.slotError = '';
            appointmentWizardState.contactError = '';
            appointmentWizardState.calendarError = '';
            handleWindowResize();
        };
        // Handles the creation of an appointment with  validations.
        const createAppointment = () => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            let isValid = true;
            if (!isNewBlockSlot.value && !hasContact.value) {
                appointmentWizardState.contactError = 'Please select a contact';
                isValid = false;
            }
            if (validateGuestCount.value) {
                appointmentWizardState.guestCountError =
                    'Guest count should be between 1 and 100';
                isValid = false;
            }
            if (calendarDropDownOptions(false).length === 0 && hasContact.value) {
                appointmentWizardState.calendarError = 'No calendars found in the location.';
                isValid = false;
            }
            if (appointmentWizardState.appointmentSlots.length === 0 &&
                !isNewBlockSlot.value &&
                !shouldAllowCustomTime.value) {
                appointmentWizardState.slotError = 'Please pick a slot.';
                isValid = false;
            }
            if (appointmentWizardState.isSlotsLoading) {
                isValid = false;
            }
            if (appointmentWizardState.isRecurringEventsLoading) {
                isValid = false;
            }
            if (appointmentWizardState.appointmentSlots.length === 0) {
                appointmentWizardState.selectedAppointmentSlot = undefined;
            }
            if (shouldAllowCustomTime.value) {
                if (!isNewBlockSlot.value &&
                    moment(appointmentWizardState.customEndTime).isBefore(appointmentWizardState.customStartTime)) {
                    alert('End time must be after start time!');
                    isValid = false;
                }
                if (isNewBlockSlot.value &&
                    moment(appointmentWizardState.blockedOffEndTime).isBefore(appointmentWizardState.blockedOffStartTime)) {
                    alert('End time must be after start time!');
                    isValid = false;
                }
            }
            if (appointmentWizardState.slotError && !shouldAllowCustomTime.value) {
                isValid = false;
            }
            if (isValid) {
                appointmentWizardState.serverError = '';
                const appointment = {
                    calendarId: appointmentWizardState.selectedCalendarId,
                    ignoreFreeSlotValidation: shouldAllowCustomTime.value,
                    locationId: AppState.locationId,
                    contact: {
                        email: ((_a = AppState === null || AppState === void 0 ? void 0 : AppState.selectedContact) === null || _a === void 0 ? void 0 : _a.email) || null,
                        phone: ((_b = AppState === null || AppState === void 0 ? void 0 : AppState.selectedContact) === null || _b === void 0 ? void 0 : _b.phone) || null,
                        id: ((_c = AppState === null || AppState === void 0 ? void 0 : AppState.selectedContact) === null || _c === void 0 ? void 0 : _c.id) || null,
                    },
                    contactId: ((_d = AppState === null || AppState === void 0 ? void 0 : AppState.selectedContact) === null || _d === void 0 ? void 0 : _d.id) || null,
                    title: isNewBlockSlot.value
                        ? appointmentWizardState.blockedOffTitle
                        : appointmentWizardState.appointmentTitle,
                    calendarNotes: appointmentWizardState.appointmentDescription,
                    startTime: moment(shouldAllowCustomTime.value
                        ? isNewBlockSlot.value
                            ? appointmentWizardState.blockedOffStartTime
                            : appointmentWizardState.customStartTime
                        : appointmentWizardState.selectedAppointmentSlot)
                        .tz(appointmentWizardState.selectedTimezone, true)
                        .format(),
                    endTime: moment(shouldAllowCustomTime.value
                        ? isNewBlockSlot.value
                            ? appointmentWizardState.blockedOffEndTime
                            : appointmentWizardState.customEndTime
                        : appointmentWizardState.selectedAppointmentSlot)
                        .tz(appointmentWizardState.selectedTimezone, true)
                        .add(shouldAllowCustomTime.value
                        ? 0
                        : ((_e = selectedCalendar.value) === null || _e === void 0 ? void 0 : _e.slotDuration) || 30, 'minutes')
                        .format(),
                    selectedTimezone: appointmentWizardState.selectedTimezone,
                    appointmentStatus: appointmentWizardState.appointmentStatus,
                    ignoreDateRange: true,
                    toNotify: false,
                    source: AppState.source,
                    channel: 'web_app',
                };
                if (hasContact.value) {
                    if (shouldCollectGuestInfo.value) {
                        appointment.guests = appointmentWizardState.guestsRef.map(guest => {
                            return {
                                id: guest.id,
                                name: guest.name,
                                fullName: guest.name,
                                email: guest.email,
                                phone: guest.phone,
                            };
                        });
                        appointment.guestCount = null;
                    }
                    else if (shouldCollectGuestCountOnly.value) {
                        if (showCountError.value) {
                            return;
                        }
                        appointment.guestCount = appointmentWizardState.guestCount;
                        appointment.guests = [];
                    }
                }
                if (appointmentWizardState.selectedTimezone !== contactTimezone.value &&
                    appointmentWizardState.shouldOverrideContactTimezone) {
                    appointment.contact.timezone = appointmentWizardState.selectedTimezone;
                }
                if ((_f = selectedCalendar.value) === null || _f === void 0 ? void 0 : _f.providerId) {
                    appointment.calendarProviderId = (_g = selectedCalendar.value) === null || _g === void 0 ? void 0 : _g.providerId;
                }
                if (!isNewBlockSlot.value &&
                    ((_h = selectedCalendar.value) === null || _h === void 0 ? void 0 : _h.isV3Calendar) &&
                    appointmentWizardState.selectedTeamMember !== 'default') {
                    appointment.userId = appointmentWizardState.selectedTeamMember;
                    appointment.assignedUserId = appointmentWizardState.selectedTeamMember;
                }
                if (appointmentWizardState.meetingLocationType.includes(appointmentWizardState.locationType)) {
                    if (appointmentWizardState.meetingLocationType.includes(appointmentWizardState.customizedLocationType)) {
                        appointment.address = appointmentWizardState.customLocation;
                        appointment.meetingLocationType =
                            appointmentWizardState.customizedLocationType;
                    }
                    else {
                        appointment.meetingLocationType =
                            appointmentWizardState.customizedLocationType;
                    }
                }
                else {
                    appointment.meetingLocationType = 'default';
                }
                appointmentWizardState.showCreateAppointmentLoader = true;
                if (!hasContact.value) {
                    delete appointment.ignoreFreeSlotValidation;
                    delete appointment.contact;
                    delete appointment.contactId;
                    delete appointment.appointmentStatus;
                    delete appointment.ignoreDateRange;
                    delete appointment.toNotify;
                    delete appointment.meetingLocationType;
                    delete appointment.address;
                    delete appointment.selectedTimezone;
                    delete appointment.calendarProviderId;
                    if (AppState.calendarPageData.isUserCalendar ||
                        appointmentWizardState.selectedUser) {
                        delete appointment.calendarId;
                    }
                    if (appointmentWizardState.blockedSelectedCalendarId)
                        appointment.calendarId =
                            appointmentWizardState.blockedSelectedCalendarId;
                    appointment.userId = appointmentWizardState.selectedUser;
                }
                try {
                    if (isEditingAppointment.value) {
                        if (!hasContact.value) {
                            yield CalendarEventService.updateBlockSlot(AppState.appointmentToBeEdited, appointment);
                        }
                        else if ((_j = AppState === null || AppState === void 0 ? void 0 : AppState.webinarDetail) === null || _j === void 0 ? void 0 : _j.appointmentIds) {
                            yield Promise.all((_k = AppState === null || AppState === void 0 ? void 0 : AppState.webinarDetail) === null || _k === void 0 ? void 0 : _k.appointmentIds.map(appointmentId => {
                                return CalendarEventService.updateAppointment(appointmentId, appointment);
                            }));
                        }
                        else {
                            yield CalendarEventService.updateAppointment(AppState.appointmentToBeEdited, appointment);
                        }
                    }
                    else {
                        if (!AppState.selectedContact) {
                            yield CalendarEventService.blockSlot(appointment);
                        }
                        else if (bookRecurring.value) {
                            yield CalendarEventService.createRecurringEvents(appointment);
                        }
                        else {
                            yield CalendarEventService.createAppointment(appointment);
                        }
                    }
                    appointmentWizardState.apptBooked = true;
                    // If successful, shows a success notification and triggers the onCancelClick event.
                    sendNotification({
                        title: AppState.isEdit
                            ? `${t('common.changes_saved')}!`
                            : isNewBlockSlot.value
                                ? `${t('common.block_created')}!`
                                : `${t('common.appointment_booked')}!`,
                        description: '',
                        type: 'success',
                    });
                    appointmentWizardState.showCreateAppointmentLoader = false;
                    setTimeout(() => {
                        props.onCancelClick();
                    }, 1000);
                }
                catch (error) {
                    // If an error occurs, sets the error message and shows an error notification.
                    appointmentWizardState.serverError =
                        'An error occured, Please try again later.';
                    const err = error;
                    console.log('err: ', err);
                    appointmentWizardState.showCreateAppointmentLoader = false;
                    sendNotification({
                        title: t('common.create_appointmet_failed'),
                        description: '',
                        type: 'error',
                    });
                }
            }
        });
        onMounted(() => {
            window.addEventListener('resize', handleWindowResize);
            handleWindowResize(); // Initialize width value
        });
        onBeforeUnmount(() => {
            window.removeEventListener('resize', handleWindowResize);
        });
        const handleWindowResize = () => {
            const baseWidth = isNewBlockSlot.value ? 536 : 956;
            const standardHeight = AppState.isNewBlockSlot
                ? 620
                : AppState.isEdit
                    ? 640
                    : 660;
            const windowWidth = window.innerWidth;
            dynamicWidth.value = isNewBlockSlot.value
                ? 536
                : Math.min(baseWidth, windowWidth - 100);
            appointmentWizardState.width = dynamicWidth.value;
            const windowHeight = window.innerHeight;
            const standardDesktopHeight = 1080;
            if (windowHeight <= standardDesktopHeight) {
                dynamicHeight.value = `${standardHeight}px`;
            }
            else {
                dynamicHeight.value = `500px`;
            }
            appointmentWizardState.height = dynamicHeight.value;
        };
        watch(() => [isNewBlockSlot, AppState.isEdit], () => {
            handleWindowResize();
        });
        const toggleDeleteModal = () => {
            showDeleteModal.value = !showDeleteModal.value;
        };
        const onClickDelete = () => {
            appointmentWizardState.apptBooked = true;
            props.onCancelClick();
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(UIModal), {
                show: __props.showModal,
                width: dynamicWidth.value
            }, {
                header: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("p", _hoisted_3, _toDisplayString(getModalHeaderText()), 1),
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, [
                                    (_unref(AppState).isEdit)
                                        ? (_openBlock(), _createBlock(_unref(Trash01Icon), {
                                            key: 0,
                                            class: "w-5 h-5 text-gray-700 cursor-pointer",
                                            onClick: toggleDeleteModal
                                        }))
                                        : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_6, [
                                    _createVNode(_unref(XCloseIcon), {
                                        class: "w-5 h-5 text-gray-700 cursor-pointer",
                                        onClick: _cache[0] || (_cache[0] = ($event) => (__props.onCancelClick()))
                                    })
                                ])
                            ])
                        ])
                    ])
                ]),
                footer: _withCtx(() => [
                    _createVNode(_unref(UIModalFooter), {
                        "positive-text": getModalFooterText(),
                        negativeText: _ctx.$t('common.cancel'),
                        onPositiveClick: createAppointment,
                        onNegativeClick: _cache[3] || (_cache[3] = ($event) => (__props.onCancelClick())),
                        loading: _unref(appointmentWizardState).showCreateAppointmentLoader,
                        id: "modal-footer"
                    }, _createSlots({ _: 2 }, [
                        (!_unref(AppState).isLoading && !_unref(isNewBlockSlot))
                            ? {
                                name: "actionLeft",
                                fn: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_11, [
                                        _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(t)('appointmentModal.status')) + " : ", 1),
                                        _createVNode(UIDropdown, {
                                            value: selectedStatusOption.value,
                                            options: _unref(statusOptions),
                                            id: "appointment-status-dropwdown",
                                            label: _unref(t)('appointmentModal.status'),
                                            "handle-change": setSelectedAppointmentStatus
                                        }, null, 8, ["value", "options", "label"])
                                    ])
                                ]),
                                key: "0"
                            }
                            : undefined
                    ]), 1032, ["positive-text", "negativeText", "loading"])
                ]),
                default: _withCtx(() => [
                    _createElementVNode("div", {
                        class: "appointmentWizardBody",
                        style: _normalizeStyle({ height: dynamicHeight.value })
                    }, [
                        (_unref(AppState).isLoading)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                _createVNode(_unref(UISpin), { class: "h-[600px] overflow-auto flex justify-center items-center" })
                            ]))
                            : _createCommentVNode("", true),
                        (_unref(AppState).showBlockedTimeAndContact &&
                            !_unref(AppState).isLoading &&
                            !_unref(AppState).isEdit)
                            ? (_openBlock(), _createBlock(_unref(UITabs), {
                                key: 1,
                                modelValue: _unref(AppState).isNewBlockSlot,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_unref(AppState).isNewBlockSlot) = $event)),
                                "onUpdate:value": _cache[2] || (_cache[2] = val => onClickTab(val)),
                                "default-value": _unref(isNewBlockSlot) ? 'blockedOff' : 'appointment'
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_unref(UITabPane), {
                                        name: "appointment",
                                        tab: _ctx.$t('appointmentModal.appointment')
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(BookAppointmentForm)
                                        ]),
                                        _: 1
                                    }, 8, ["tab"]),
                                    _createVNode(_unref(UITabPane), {
                                        name: "blockedOff",
                                        tab: _ctx.$t('appointmentModal.blocked_off_time')
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(CreateBlockedTimeForm)
                                        ]),
                                        _: 1
                                    }, 8, ["tab"])
                                ]),
                                _: 1
                            }, 8, ["modelValue", "default-value"]))
                            : _createCommentVNode("", true),
                        (!_unref(AppState).showBlockedTimeAndContact && !_unref(AppState).isLoading)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                _createVNode(BookAppointmentForm)
                            ]))
                            : _createCommentVNode("", true),
                        (!_unref(AppState).isLoading && _unref(AppState).isEdit)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                (!_unref(isNewBlockSlot))
                                    ? (_openBlock(), _createBlock(BookAppointmentForm, { key: 0 }))
                                    : (_openBlock(), _createBlock(CreateBlockedTimeForm, { key: 1 }))
                            ]))
                            : _createCommentVNode("", true)
                    ], 4),
                    _hoisted_10,
                    _createVNode(DeleteAppointmentModal, {
                        "show-modal": showDeleteModal.value,
                        "event-id": _unref(AppState).appointmentToBeEdited,
                        "on-cancel-click": toggleDeleteModal,
                        "on-delete-click": onClickDelete
                    }, null, 8, ["show-modal", "event-id"])
                ]),
                _: 1
            }, 8, ["show", "width"]));
        };
    }
});
